import React from 'react';
import { FormStatus, QRCode } from '@lib/state';
import { ErrorDisplay, FormTextField, LoadingIndicator, SubmitButton } from '@lib/common';
import { Box, Grid, Typography } from '@material-ui/core';

interface Props {
  qrcode: QRCode;
  status: FormStatus;
  error?: Error;
}

export const FeedbackForm: React.FC<Props> = ({ qrcode, status, error }) => {
  if (status !== FormStatus.Success)
    return (
      <>
        <Box display="flex" alignItems="center" justifyContent="space-between" pb={2}>
          <Typography variant="h5" paragraph>
            <strong>Submit Feedback</strong>
          </Typography>
        </Box>
        <Grid container spacing={4} alignItems="center">
          {!!qrcode.name && (
            <Grid item xs={12} md={4}>
              <Typography>
                <strong>Name</strong>
              </Typography>
              <Typography>{qrcode.name}</Typography>
            </Grid>
          )}
          {!!qrcode.location && (
            <Grid item xs={12} md={4}>
              <Typography>
                <strong>Area</strong>
              </Typography>
              <Typography>{qrcode.location}</Typography>
            </Grid>
          )}
          <Grid item xs={12}>
            <strong>Feedback *</strong>
            <FormTextField
              name="notes"
              fullWidth
              minRows={3}
              multiline={true}
              required
              placeholder="Enter feedback here"
              helperText="If immediate assistance is required, please visit the front desk."
            />
          </Grid>
        </Grid>
        <ErrorDisplay error={error} />
        {status === FormStatus.Pending ? <LoadingIndicator loadingText="Processing..." /> : null}
        <Box display="flex" justifyContent="flex-end" pb={2}>
          <SubmitButton
            variant="contained"
            color="secondary"
            fullWidth
            pending={status === FormStatus.Pending}
            disabled={status === FormStatus.Pending}
          >
            Submit
          </SubmitButton>
        </Box>
      </>
    );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h5" align="center" color="textSecondary" paragraph>
          Feedback Submitted
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" align="center">
          Thank you, your feedback has been received. A manager will review.
        </Typography>
      </Grid>
    </Grid>
  );
};
